import { CatHeading } from 'components/blocks-components';
import styles from '../../request-equipment-service.module.scss';
import cx from 'classnames';
import { Conditional, CustomStyledLabel } from '@cat-ecom/pcc-components';
import { useTranslations } from 'next-intl';
import RequestServicePartDetailsInfo from '../request-service-part-details-info';
import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { RequestServicePartDetailsProps } from 'components/request-equipment-service/types';

const RequestServicePartDetails = ({
  partDetails
}: Readonly<RequestServicePartDetailsProps>) => {
  const t = useTranslations();

  return (
    <>
      <CatHeading variant="label">
        <CustomStyledLabel className={cx(styles['color'])}>
          {t('REQUEST_SERVICE_CONFIRMATION_SEA_INFORMATION')}:
        </CustomStyledLabel>
      </CatHeading>
      <Conditional test={!isEmpty(partDetails.partName)}>
        <RequestServicePartDetailsInfo
          label={t('SEA_NAME')}
          value={partDetails.partName}
          classname="mt-2"
        />
      </Conditional>
      <Conditional test={!isEmpty(partDetails.partNumber)}>
        <RequestServicePartDetailsInfo
          label={t('Quick_Col1')}
          value={partDetails.partNumber}
          classname="mt-3"
        />
      </Conditional>
    </>
  );
};
export default RequestServicePartDetails;
